import { BankAccount } from '../Model/BankAccount';
import { ExtendedTransaction, Transaction } from '../Model/Transaction';
import { TransactionFilter } from '../Model/Others';
import { storeApi } from './storeApi';

export const transactionApi = storeApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransactionByBankAccount: builder.query<
      ExtendedTransaction[],
      { selectedBankAccounts: TransactionFilter[]; showBooked?: boolean; page?: number; companyId: string }
    >({
      query: ({ selectedBankAccounts, showBooked, page, companyId }) => {
        return {
          url: page ? `/bankaccounts-transactions/${page}` : `/bankaccounts-transactions/`,
          method: 'POST',
          body: { bankAccounts: selectedBankAccounts, booked: showBooked, company_id: companyId },
        };
      },
      transformResponse: (response: ExtendedTransaction[]) => {
        return response.map((dt) => ({
          ...dt,
          ...{ amountWithCurrency: { amount: dt.amount, currency: dt.currency ? dt.currency : 'HUF' } },
        }));
      },
      providesTags: (result) =>
        result
          ? [...result.map(({ _id }) => ({ type: 'Transaction', _id } as const)), { type: 'Transaction', id: 'LIST' }]
          : [{ type: 'Transaction', id: 'LIST' }],
    }),
    exportTransaction: builder.mutation<
      Transaction[],
      { bank_accounts: Partial<BankAccount>[]; start_date: string; end_date: string; companyId: string }
    >({
      query: ({ bank_accounts, start_date, end_date, companyId }) => ({
        url: '/bankaccount/export',
        method: 'POST',
        body: { bank_accounts, start_date, end_date, company_id: companyId },
      }),
    }),
    logBooked: builder.mutation<void, { transactionId: string }>({
      query: ({ transactionId }) => ({
        url: '/booked',
        method: 'POST',
        body: { transactionId },
      }),
    }),
  }),
});

export const { useLazyGetTransactionByBankAccountQuery, useExportTransactionMutation, useLogBookedMutation } =
  transactionApi;
